( function( $ ) {
	function isInViewportCounter( $element ) {
		if ( ! $element.length ) {
			return false;
		}

		const rect = $element[ 0 ].getBoundingClientRect();
		const elementMid = rect.top + rect.height / 2;

		return elementMid > 0 && elementMid < window.innerHeight;
	}

	function runCounters() {
		$( '.odometer' ).each( function() {
			const $this = $( this );

			if ( ! $this.hasClass( 'animated' ) && isInViewportCounter( $this ) ) {
				const target = $this.data( 'number' );

				if ( target !== undefined ) {
					setTimeout( function() {
						$this.text( target );
					}, 300 );

					$this.addClass( 'animated' );
				}
			}
		} );
	}

	$( window ).on( 'scroll load resize touchmove', runCounters );
	runCounters();
}( jQuery ) );
